export default import.meta.ROLLDOWN_FILE_URL_hO7VBBXnOl1k4ErpMlvAaA